export default "assets/images/flags/hu-e1185a88.svg";